import { render, staticRenderFns } from "./share-links.vue?vue&type=template&id=24ef0bc9&scoped=true&lang=pug&"
import script from "./share-links.vue?vue&type=script&lang=coffee&"
export * from "./share-links.vue?vue&type=script&lang=coffee&"
import style0 from "./share-links.vue?vue&type=style&index=0&id=24ef0bc9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef0bc9",
  null
  
)

export default component.exports